var _ = require('underscore'),
    NotesCollection = require('../../../notes/models/notes'),
    NoteModelFactory = require('../factory/factory'),
    fvChannel = require('glRadio').channel('FV');


module.exports = NotesCollection.extend({

    url: function() {
        return fvChannel.request('apiUrl').pageNotes;
    },

    // Currently not in use -- ( now retreived from docInfo )
    // Note: there are 2: one on the document (POST) and other is a get -- here is the POST
    fetch: function() {

        return Backbone.Collection.prototype.fetch.call( this, {
            type: 'POST',
            data:  JSON.stringify( [ this.document.getDocSlice() ] ) ,
            contentType: 'application/json' // must include or server responds with 415
        } );

    },

    parse: function(resp) {

        var availableNoteTypes = NoteModelFactory.noteTypesToInclude('page');
        resp =_.filter(resp, function(n) {
            return _.contains(availableNoteTypes, n.noteType);
        });

        return resp;

    },

    model: function(attrs, options) {

        delete options.url;  //looks like set by default: need to delete prior to model creation to allow for rootURL to take precedence over the collections' //TODO: still using?
        var Note = NoteModelFactory.factory( attrs.noteType, false );
        return new Note(attrs, options);

    },

    /**
     *  pageNumber: set from page collection where the pageId of the pageNote is the pageId of the page
     * (pageNumbers are set in the parse of the page collection from the array index of the model
     * the notes have an id -- map with the document page numbers
     */
    setPageNumbers: function(pgCollection) {

        var pgNotes = this.models,
            pgs = pgCollection.models;

        _.each( pgNotes, function(pn) {

            var pgNum = _.find(pgs, function(pg) {
                return pg.get('pageId') === pn.get('pageId');
            }).get('number');

            pn.pageNumber = pgNum; // not a server prop

        });

    },

    // Need to use link on pageId, not page # ( which is based on sequence ).
    // This is because documents can have > 1 copy of the same page,
    // and accordingly, > 1 page can share the same notes.
    getNotesOfPage: function(page) {
        return this.filter( function(n) {
            return n.get('pageId') === page.get('pageId');
        });
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/pgNotes.js
 ** module id = 270
 ** module chunks = 0
 **/